import { apiClient } from './api';

function unwrapData<T>(res: { success: boolean; data?: T; message?: string; error?: string }, fallbackMsg: string): T {
  if (!res.success || res.data === undefined) {
    throw new Error(res.message || res.error || fallbackMsg);
  }
  return res.data;
}

export type ContactReadStatus = 'unread' | 'read' | '';

export type ContactMessageRow = {
  id: string;
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
  isRead: boolean;
  createdAt: string;
};

type PageResult<T> = {
  data: T[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
};

function mapRow(raw: Record<string, unknown>): ContactMessageRow {
  return {
    id: String(raw.id ?? ''),
    name: String(raw.name ?? ''),
    email: String(raw.email ?? ''),
    phone: String(raw.phone ?? ''),
    subject: String(raw.subject ?? ''),
    message: String(raw.message ?? ''),
    isRead: Boolean(raw.isRead),
    createdAt: String(raw.createdAt ?? ''),
  };
}

export const SUBJECT_LABELS: Record<string, string> = {
  order: 'پیگیری سفارش',
  return: 'مرجوعی کالا',
  warranty: 'گارانتی و خدمات پس از فروش',
  suggestion: 'پیشنهاد و انتقاد',
  business: 'همکاری تجاری',
  other: 'سایر موارد',
};

export function subjectLabel(subject: string) {
  return SUBJECT_LABELS[subject] ?? subject;
}

export const contactService = {
  async list(params: { page?: number; limit?: number; status?: ContactReadStatus } = {}): Promise<PageResult<ContactMessageRow>> {
    const res = await apiClient.get<PageResult<Record<string, unknown>>>('/admin/contact-messages', { params });
    const page = unwrapData(res, 'خطا در دریافت پیام‌ها');
    return {
      ...page,
      data: (page.data ?? []).map(mapRow),
    };
  },
  async markRead(id: string) {
    const res = await apiClient.patch(`/admin/contact-messages/${id}/read`);
    unwrapData(res, 'خطا در علامت‌گذاری پیام');
  },
  async remove(id: string) {
    const res = await apiClient.delete(`/admin/contact-messages/${id}`);
    unwrapData(res, 'خطا در حذف پیام');
  },
};
